define('charts/layers/polarlayer',["require", "exports", "../../baseline/colors"], function (require, exports, colors_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PolarLayer = void 0;
    var PolarLayer = /** @class */ (function () {
        function PolarLayer(track, options) {
            this.track = track;
            this.options = options;
        }
        PolarLayer.prototype.init = function (chart) {
            var _this = this;
            // Add svg group
            this.svgGroup = chart.layers.polars.append("g")
                .attr("class", "polar " + this.track.track_id)
                .style("fill", "none")
                .style("stroke-width", 2);
            // Construct d3 line
            this.polarCurve = d3.line()
                .defined(function (d) { return _this.isReal(d); })
                .x(function (d) { return chart.xAxis.scale(_this.options.fx(d)); })
                .y(function (d) { return chart.yAxis[0].scale(_this.options.fy(d)); });
        };
        PolarLayer.prototype.update = function (chart) {
            var _this = this;
            // Update the polar plot line
            var segments = this.track.segments();
            var paths = this.svgGroup.selectAll("path")
                .data(segments);
            paths.enter()
                .append("path")
                .attr("class", function (d) { return "polar-segment " + d.mode; })
                .style("stroke", function (d) { return (0, colors_1.pathColor)(d.mode); })
                .merge(paths)
                .attr("d", function (d) { return _this.polarCurve(d.data); });
            paths.exit()
                .remove();
        };
        PolarLayer.prototype.remove = function () {
            this.svgGroup.remove();
        };
        PolarLayer.prototype.isReal = function (d) {
            return isFinite(this.options.fx(d)) && isFinite(this.options.fy(d));
        };
        return PolarLayer;
    }());
    exports.PolarLayer = PolarLayer;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/polarlayer.js.map;
